import axios from 'axios';
import {
  FeatureFlag,
  isFeatureEnabled,
} from '../components/account/userSettings/DebugForm';
import { RailwayFeatureFlag } from '../railwayFeatureFlags';

type FeatureFlagSource = 'Debug' | 'Railway';
const useFeatureFlag = () => {
  async function isActive(
    flag: FeatureFlag,
    source?: 'Debug'
  ): Promise<boolean>;
  async function isActive(
    flag: RailwayFeatureFlag,
    source: 'Railway'
  ): Promise<boolean>;
  async function isActive(
    flag: FeatureFlag | RailwayFeatureFlag,
    source: FeatureFlagSource = 'Debug'
  ) {
    if (source === 'Debug') return isFeatureEnabled(flag as FeatureFlag);
    if (source === 'Railway') {
      try {
        const response = await axios.get(`/feature-flags/?ff=${flag}`);
        return response.data?.is_active ?? false;
      } catch (error) {
        console.error('Failed to fetch feature flag from Railway:', error);
        return false;
      }
    }
    return false;
  }

  return { isActive };
};

export default useFeatureFlag;
